import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  QuestionnaireTenxFormField,
  QuestionnaireTenxOption
} from './tenx.interface';
import { QuestionnaireTenxState } from './tenx.state';

export const QuestionnaireTenxActions = createActionGroup({
  source: 'Questionnaire Tenx',
  events: {
    Reset: emptyProps(),

    // Setters State
    'Set Form': props<{
      key: QuestionnaireTenxFormField;
      value:
        | Array<QuestionnaireTenxOption>
        | QuestionnaireTenxOption
        | number
        | string
        | null;
    }>(),
    'Set Loading': props<{
      key: keyof QuestionnaireTenxState['loading'];
      value: boolean;
    }>(),
    'Set User Profile': props<{
      value: QuestionnaireTenxState['userProfile'];
    }>(),
    'Set Submission Response':
      props<QuestionnaireTenxState['submissionResponse']>(),

    // Fetching
    'Fetch User Profile': emptyProps(),

    // Mutations
    Submit: emptyProps()
  }
});
